<div class="redline-wrapper">
  <canvas #redlineCanvas class="redline-canvas"></canvas>
</div>
